/**
 * @author Toru Nagashima <https://github.com/mysticatea>
 */
"use strict";

module.exports = {
    isCombiningCharacter: require("./is-combining-character"),
    isEmojiModifier: require("./is-emoji-modifier"),
    isRegionalIndicatorSymbol: require("./is-regional-indicator-symbol"),
    isSurrogatePair: require("./is-surrogate-pair")
};
